import { stringEnum } from '@/models/type-generators/string-enum';

export type Status = 'SELECTED' | 'NOT_SELECTED';
export const Status = stringEnum<Status>();
